// src/components/CardAnimated.tsx
import React, { useEffect, useState } from 'react';

export default function CardAnimated({ children }: { children?: React.ReactNode }) {
  const [play, setPlay] = useState(false);

  useEffect(() => {
    // Delay tiny para evitar flashes y problemas con SSR/hydration
    const id = setTimeout(() => setPlay(true), 500);
    return () => clearTimeout(id);
  }, []);

  return (
    <div
      // puedes usar utilidades Tailwind + la clase de la animación
      className={` ${play ? 'anim-swing-in-top-fwd' : 'opacity-0'}`}
      // sobrescribir duración si quieres por instancia:
      style={{ ['--anim-swing-duration' as any]: '0.6s' } as React.CSSProperties}
    >
      {children}
    </div>
  );
}
